export default [
    {
        name: "getPendingTherapyFeedback",
        path: 'user/therapy-results/pending',
        method: "get", loading: false, alert: false,
        defaultHeader: {}, defaultBody: {}, commits: []
    },
    {
        name: "SendSurveyAnswer",
        path: 'user/onboarding-survey',
        method: "post",
        loading: true,
        alert: true,
        defaultHeader: {},
        defaultBody: {},
        commits: []
    },
    {
        name: "setPassword",
        path: 'set-password',
        method: "post",
        loading: true,
        alert: true,
        defaultHeader: {},
        defaultBody: {},
        commits: []
    },
    {
        name: "insertCycle",
        path: 'user/cycles',
        method: "post",
        loading: true,
        alert: true,
        defaultHeader: {},
        defaultBody: {},
        commits: []
    },
    {
        name: "request-test-analysis",
        path: 'user/request-test-analysis',
        method: "post",
        loading: true,
        alert: true,
        defaultHeader: {},
        defaultBody: {},
        commits: []
    },
    {
        name: "getInvitees",
        path: 'user/invitees',
        method: "post",
        loading: true,
        alert: true,
        defaultHeader: {},
        defaultBody: {},
        commits: []
    },
    {
        name: "processStaticPresession",
        path: 'user/process-static-presession',
        method: "post",
        loading: true,
        alert: true,
        defaultHeader: {},
        defaultBody: {},
        commits: []
    },
    {
        name: "getEventStatus",
        path: 'user/events/:id/status',
        method: "get",
        loading: true,
        alert: true,
        defaultHeader: {},
        defaultBody: {},
        commits: []
    },
    {
        name: "startPreSessionAiFlow",
        path: 'user/psychepro/start-flow',
        method: "post",
        loading: true,
        alert: true,
        defaultHeader: {},
        defaultBody: {},
        commits: []
    },

    {
        name: "canAttendPreSession",
        path: 'user/presession/can-attend-presession',
        method: "get",
        loading: true,
        alert: true,
        defaultHeader: {},
        defaultBody: {},
        commits: []
    },
    {
        name: "getAssignRecord",
        path: 'user/outcome/assign-records',
        method: "get",
        loading: true,
        alert: true,
        defaultHeader: {},
        defaultBody: {},
        commits: []
    },
    {
        name: "assignTherapist",
        path: 'user/assign-therapist',
        method: "post",
        loading: true,
        alert: true,
        defaultHeader: {},
        defaultBody: {},
        commits: []
    },
    {
        name: "getMyoutcomeChart",
        path: 'user/outcome/:assignRecordId/chart',
        method: "get",
        loading: true,
        alert: true,
        defaultHeader: {},
        defaultBody: {},
        commits: []
    },


]
